import { DragAndDropContainer } from 'framework/components/dnd/DragAndDropContainer';
import { LeftRightDividedContentScrollYRight } from 'framework/components/LeftRightDividedContentScrollYRight';
import { useSnackbarNotify } from 'framework/hooks/useSnackbarNotify';
import { addOrUpdateQuantity } from 'framework/utils/array/addOrUpdateQuantity';
import { updateArray } from 'framework/utils/array/updateArray';
import {
	IInventoryItem,
	IInventoryItemsQueryParamsForStockMovement,
	inventoryItemsQuery_queryForStockMovement,
	IProductCatalogItem,
	IProductCatalogQueryParamsForStockMovement,
} from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useContext } from 'react';
import { DefaultInventoryItemsQueryParamsForStockMovement } from 'shared/searchAndSelect/DefaultInventoryItemsQueryParamsForStockMovement';
import { SearchStockProductCatalogInventoryItemTabs } from 'shared/searchAndSelect/SearchStockProductCatalogInventoryItemTabs';
import { SearchContext } from './context/SearchContext';
import { ILine } from './ILine';
import { StockMovementLineComponent } from './StockMovementLineComponent';
import { inventoryItemToLine } from './utils/inventoryItemToLine';
import { productCatalogItemToLine } from './utils/productCatalogItemToLine';

interface IProps {
	lines: ILine[];
	setLines: React.Dispatch<React.SetStateAction<ILine[]>>;
}

export const SearchAndSelectProductsForStockMovement = ({ lines, setLines }: IProps) => {
	const notify = useSnackbarNotify();
	const strings = useLocalization();
	const { ...allSearchParams } = useContext(SearchContext);

	const onAddPc = (item: IProductCatalogItem) => {
		setLines(addOrUpdateQuantity(item, lines, () => productCatalogItemToLine(item)));
	};

	const onAddII = (item: IInventoryItem, pc: IProductCatalogItem) => {
		if (lines.findIndex(t => t.inventoryItemId === item.id) > -1) {
			notify(strings.itemAlreadyInList, 'warning');
		} else {
			setLines([...lines, inventoryItemToLine(item, pc)]);
		}
	};

	return (
		<LeftRightDividedContentScrollYRight
			leftContent={
				<SearchStockProductCatalogInventoryItemTabs<ILine, IInventoryItemsQueryParamsForStockMovement, IProductCatalogQueryParamsForStockMovement>
					lines={lines}
					{...allSearchParams}
					queryInventoryItemF={inventoryItemsQuery_queryForStockMovement}
					defaultIIParams={DefaultInventoryItemsQueryParamsForStockMovement}
					onAddII={onAddII}
					onAddPc={onAddPc}
					canSelectInventoryItemF={i => i.canSelectForStockMovement}
				/>
			}
			rightContent={
				<DragAndDropContainer<ILine>
					lines={lines}
					setLines={setLines}
					getKey={t => t.id}
					render={(line, index, props) => (
						<StockMovementLineComponent
							line={line}
							index={index + 1}
							dragHandleProps={props}
							setLine={val => setLines(updateArray(line, lines, val))}
							onDelete={() => setLines(lines.filter(t => t !== line))}
						/>
					)}
				/>
			}
		/>
	);
};
